<template>
  <div class="bg-pattern"></div>
  <router-view/>
</template>

<script>
import { getFooterInfo } from '@/api/config'

export default {
  name: 'App',
  async created() {
    // 获取网站信息并设置标题
    try {
      const response = await getFooterInfo()
      if (response.code === 1 && response.data.site_name) {
        document.title = response.data.site_name
      }
    } catch (error) {
      console.error('获取网站信息失败:', error)
    }
  }
}
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
  position: relative;
  overflow-x: hidden;
}

.bg-pattern {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f5f5f7;
  background: 
    radial-gradient(circle at 10% 20%, rgba(0, 122, 255, 0.03) 0%, transparent 20%),
    radial-gradient(circle at 80% 40%, rgba(0, 122, 255, 0.05) 0%, transparent 30%),
    radial-gradient(circle at 40% 70%, rgba(0, 122, 255, 0.04) 0%, transparent 25%);
  z-index: -1;
  pointer-events: none;
}

body {
  margin: 0;
  padding: 0;
  background-color: #f5f5f7;
}
</style>
